/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('staticHtmlPageControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment']);